<div class="header">
  <div class="header-actions" *ngIf="!disabled">
    <h4>{{ 'brand.prepTime.itemThresholds' | translate }}</h4>
  </div>
</div>

<div class="form-content" [formGroup]="form">
  <div>
    <label>{{ 'store.dynamicPrepTime.itemThresholdMaxItems' | translate }}</label>

    <mat-form-field class="max-items">
      <mat-label>{{ 'store.dynamicPrepTime.items' | translate }}</mat-label>
      <input matInput
             txpIntegersOnly
             data-qa-label="MaxItems"
             formControlName="itemThresholdMaxItems">
      <mat-error>
        {{ 'form.error.minValueShort' | translate }}
      </mat-error>
    </mat-form-field>
  </div>

  <div>
    <label>{{ 'store.dynamicPrepTime.itemThresholdAdditionalTime' | translate }}</label>

    <mat-form-field class="additional-time">
      <mat-label>{{ 'store.dynamicPrepTime.minutes' | translate }}</mat-label>
      <input matInput
             txpIntegersOnly
             data-qa-label="AdditionalTime"
             formControlName="itemThresholdAdditionalTime">
      <mat-error>
        {{ 'form.error.required' | translate}}
      </mat-error>
    </mat-form-field>
  </div>
</div>

